import { ReactNode } from "react";
import useLayout from "./util/useLayout";
import styled from "styled-components";



interface EditorPreviewContainerProps {
  children: ReactNode;
}


const EditorPreviewContainer: React.FC<EditorPreviewContainerProps> = ({ children }) => {
  const { isSmallScreen } = useLayout();

  return (
    <ScrollerDiv className="ScrollerDiv" $usePageScroll={isSmallScreen}>
      <Stacker $isSmallScreen={isSmallScreen}>
        {children}
      </Stacker>
    </ScrollerDiv>
  );
};

interface ScrollerDivProps {
  $usePageScroll: boolean;
}

const ScrollerDiv = styled.div<ScrollerDivProps>`
  flex: 1;
  width: 100%;
  display: flex;
  overflow: hidden; 
  height: ${(props) => (props.$usePageScroll ? 'auto' : 'calc(100vh - 55px)')};
`;

interface SmallScreenable {
  $isSmallScreen: boolean;
}

const Stacker = styled.div<SmallScreenable>`
  display: flex;
  flex-direction: ${(props) => props.$isSmallScreen ? 'column' : 'row'};
  max-width: ${(props) => props.$isSmallScreen ? '100%' : '1200px'};
  min-height: 0px;
  width: 100%;
  margin: 0 auto; /* Centers the container */
  height: ${(props) => props.$isSmallScreen ? 'auto' : 'calc(100vh - 55px)'};
`;

export default EditorPreviewContainer;

